import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class FlatfileWrapper extends DatabaseWrapper {
	dbTyp_Id: number;
	name: string;
	code: string;
	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.flatfile.ID;
		this.name = DatabaseEnum.flatfile.NAME;
		this.code = DatabaseEnum.flatfile.CODE;
		this.equivalentTag = DatabaseEnum.flatfile.EQUIVALENT_TAG;
		this.showDatabaseTab = false;
		//data object tabs
		this.showDataObjectPropertiesTab = true;
		this.showViewDataTabOption = true;
		this.isShowObjProperties = true;
		this.isFileType = true;
		this.showPropertiesTab = false;
		this.isShowPIIColumn = true;
		this.importFileProperties();
    this.showDataDescription = false;
	}
	validateRepConn(repConnWrapper: RepConnWrapper): void {
		console.log('factory:: FlatfileWrapper:: validateRepConn()::');

		if (repConnWrapper.repConn.conn.ftpFlag == 'Y') {
			if (!repConnWrapper.repConn.conn.ftpHost.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_HOST');
				else if (repConnWrapper.repConn.conn.fileProtocol == 'SFTP')
					repConnWrapper.inValid_Cds.push('NO_SFTP_HOST');


			}
			if (!repConnWrapper.repConn.conn.ftpPort.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_PORT');
				else if (repConnWrapper.repConn.conn.fileProtocol == 'SFTP')
					repConnWrapper.inValid_Cds.push('NO_SFTP_PORT');

			}
			if (!repConnWrapper.repConn.conn.ftpUsr.length) {
				if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
					repConnWrapper.inValid_Cds.push('NO_FTP_CONN_USR');
				else if (repConnWrapper.repConn.conn.fileProtocol == 'SFTP')
					repConnWrapper.inValid_Cds.push('NO_SFTP_CONN_USR');

			}
			if (!repConnWrapper.repConn.conn.ftpPasswd.length) {
				if (repConnWrapper.repConn.conn.sftpAuthMode != "key") {
					if (repConnWrapper.repConn.conn.fileProtocol == 'FTP')
						repConnWrapper.inValid_Cds.push('NO_FTP_PASSWORD');
					else if (repConnWrapper.repConn.conn.fileProtocol == 'SFTP')
						repConnWrapper.inValid_Cds.push('NO_SFTP_PASSWORD');
				}
			}

			if (repConnWrapper.repConn.conn.fileProtocol == 'S3') {
				if (repConnWrapper.repConn.conn.amazonS3Host == '') {
					repConnWrapper.inValid_Cds.push('AMAZON_S3_HOST');
				}
				if (repConnWrapper.repConn.conn.bucketNm == '') {
					repConnWrapper.inValid_Cds.push('BUCKET_NM');
				}
				if (repConnWrapper.repConn.conn.accessToken == '') {
					repConnWrapper.inValid_Cds.push('ACCESS_KEY');
				}
				if (repConnWrapper.repConn.conn.accessTokenSecret == '') {
					repConnWrapper.inValid_Cds.push('SECRET_KEY');
				}
			}

			//piyush & sharmi 09-10-24
			if (repConnWrapper.repConn.conn.fileProtocol == 'Sharepoint') {
				if (repConnWrapper.repConn.conn.secToken == '') {
					repConnWrapper.inValid_Cds.push('AMAZON_S3_HOST');
				}
				if (repConnWrapper.repConn.conn.consumerKey == '') {
					repConnWrapper.inValid_Cds.push('BUCKET_NM');
				}
				if (repConnWrapper.repConn.conn.consumerSecret == '') {
					repConnWrapper.inValid_Cds.push('ACCESS_KEY');
				}
				// if (repConnWrapper.repConn.conn.accessTokenSecret == '') {
				// 	repConnWrapper.inValid_Cds.push('SECRET_KEY');
				// }
			}



		}

		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}

	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper,true),
			this.attributeTabulator.getNotNullFlag(objectWrapper),
			this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	getSourceAttributeColumns(objectWrapper: ObjectWrapper, isComplex: boolean = false, isShowPIIColumn: boolean = false,
		 isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false, isMax: boolean = false,component:any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper,component),
		]
	}

	importFileProperties = function() {
		this.showFileTypeGroup = true;
		this.showDelimiter = true;
		this.showFixedWidth = true;
	}

	readFileCutOffLength(type: string): number {
        if( type == "FILE" ){
            return 49; //default 50 lines index starts from 0
        }

        return -1;
    }

}
